<template>
    <v-container fill-height fluid>
        <v-row no-gutters>
            <v-col cols="12" class="text-center pt-3">
                <h3 class="text--white80"></h3>
                <v-row no-gutters align="center" justify="center" class="pt-3 pb-5">
                    <v-col cols="6" class=" px-8">
                        <v-row no-gutters justify="center">
                            <v-col cols="12" class="header text--withe70">
                                Consumption
                            </v-col>
                            <v-col cols="12" @click=" ()=> { showGrafDialog1 = true; }">
                                <Battery :voltage="power1"
                                         :loading="statusLoading"
                                         :warning="voltageWarning1"
                                         :batteryType="getBatteryType(power1)" />
                                <VoltageGraph v-model="showGrafDialog1" :id="'Battery1'" :subtitle="'Main battery'"></VoltageGraph>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6" class="text-center px-8">
                        <v-row no-gutters justify="center">
                            <v-col cols="12" class="header text--withe70">
                                Starter
                            </v-col>
                            <v-col cols="12" @click="()=>{showGrafDialog2 = true;}">
                                <Battery :voltage="power2"
                                         :loading="statusLoading"
                                         :warning="voltageWarning2"
                                         :batteryType="getBatteryType(power2)" />
                                <VoltageGraph v-model="showGrafDialog2" :id="'Battery2'" :subtitle="'Starter battery'"></VoltageGraph>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" align-self="stretch" class="py-5">
                <AlarmButton :armed="armed"></AlarmButton>
            </v-col>
            <v-row no-gutters class="py-2">
                <v-col cols="12" align-self="end" class="py-2">
                    <v-row no-gutters align="center"
                           justify="center">
                        <span class="text--white80">{{ temperature }}&deg; C</span>
                    </v-row>
                    <v-row no-gutters align="center"
                           justify="center">
                        <span class="text--withe70 caption">Cabin</span>
                    </v-row>
                </v-col>
                <v-col cols="12" align-self="end">
                    <SilenceButton v-if="isSilenceSirenAvailable" />
                </v-col>
            </v-row>
        </v-row>
        <v-row no-gutters justify="end">
            <v-col cols="12" align-self="end">
                <SensorPanelContainer v-model="panel" :lastHeard="gpsLocationAge">
                    <ShorePowerItem :value="shorePowerModel" @enroll="openEnroll" @unpair="unpair">Shore Power</ShorePowerItem>
                    <SmartPlugItem :value="smartplugModel" @enroll="openEnroll" @unpair="unpair">Smart Plug</SmartPlugItem>
                    <DoorSensorItem :value="doorsensorModel" @enroll="openEnroll" @unpair="unpair">Main Door</DoorSensorItem>
                    <HatchSensorItem :value="hatchsensorModel" @enroll="openEnroll" @unpair="unpair">Deck Hatch Sensor</HatchSensorItem>
                </SensorPanelContainer>
            </v-col>
            <v-col cols="12" align-self="end">
                <v-list id="homeList">
                    <v-list-item-group color="primary">
                        <v-list-item class="mob" @click="goToMob">
                            <v-list-item-content>
                                <v-list-item-icon>
                                    <v-img class="sensor-icon"
                                           max-width="52px"
                                           src="@/assets/icons/mobY.svg"></v-img>
                                </v-list-item-icon>
                                <v-list-item-title>MOB - MAN OVER BOARD, PHONE LOCATION</v-list-item-title>
                                <!--<v-list-item-subtitle>
                                    (Or Just share your location with a
                                    friend)
                                </v-list-item-subtitle>-->
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-col>
            <v-col cols="12" class="d-flex text-center" align="center" justify="center">
                <v-row no-gutters align="center" justify="center">
                    <v-col cols="12" sm="10" md="8" lg="6" class="white70--text caption">
                        <span class="metric">Latitude: {{ latitude }}&deg;{{ latLetter }}</span>
                        <span class="sep" aria-hidden="true">|</span>
                        <span class="metric">Longitude: {{ longitude }}&deg;{{ lngLetter }}</span>
                        <span class="sep" aria-hidden="true">|</span>
                        <span class="metric">Accuracy: {{ accuracy }}</span>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";
    import { alarm, app, sensor } from "@/store";
    import AttachedDeviceModel from "@/models/AttachedDeviceModel";
    import {
        computed,
        defineComponent,
        getCurrentInstance,
        onBeforeUnmount,
        onMounted,
        ref
    } from "vue";
    import { ILocationFromParticle } from "../models/AlarmStatus";
    import useTemperature from "@/store/useTemperature";
    import TemperatureViewModel from "@/models/TemperatureViewModel";
    import { VPagination } from "vuetify/lib/components";
    import { enrollState } from '@/store';
    import { enrollUi } from '@/store/enrollUi';
    import {
        resolveGeolocationAccess,
    } from "@/utilities/useGeolocation";

    export default defineComponent({
        name: "Home",
        components: {
            Battery: () =>
                import(/* webpackChunkName: "components" */ "./components/BatteryView.vue"),
            AlarmButton: () =>
                import(
        /* webpackChunkName: "components" */ "./components/ArmDisarmButton.vue"
                ),
            SilenceButton: () =>
                import(
                    /* webpackChunkName: "components" */ "./components/SilenceButton.vue"
                ),
            SensorItem: () =>
                import(
        /* webpackChunkName: "components" */ "./components/Sensors/DefaultSensorListItem.vue"
                ),
            ShorePowerItem: () =>
                import(
        /* webpackChunkName: "components" */ "./components/Sensors/ShorePowerListItem.vue"
                ),
            SmartPlugItem: () =>
                import(
        /* webpackChunkName: "components" */ "./components/Sensors/SmartPlugListItem.vue"
                ),
            DoorSensorItem: () =>
                import(
        /* webpackChunkName: "components" */ "./components/Sensors/DoorSensorListItem.vue"
                ),
            HatchSensorItem: () =>
                import(
        /* webpackChunkName: "components" */ "./components/Sensors/HatchSensorListItem.vue"
                ),
                SensorPanelContainer: () =>
                import(
            /* webpackChunkName: "components" */ "./components/Sensors/SensorPanelContainer.vue"
                ),
            VoltageGraph: () =>
                import(
        /* webpackChunkName: "components" */ "./components/Dialogs/VoltageDialog.vue"
                )
        },
        setup() {
            const root = getCurrentInstance()?.proxy as any;
            const showGrafDialog1 = ref<boolean>(false);
            const showGrafDialog2 = ref<boolean>(false);
            const connectSensor = ref<AttachedDeviceModel>();
            const gpsLocationAge = ref<string>("");
            let lastGpsTime: Date | null = null;
            let lastHeardIntervalId: any | null = null;
            let stopLastKnownLocationWatch: Function | null = null;
            const { get } = useTemperature();
            const smallVoltageLimit = 0.5;
            const lowVoltageLimit12V = 11.8;
            const highVoltageLimit12V = 14.8;
            const lowVoltageLimit24V = 23.6;
            const highVoltageLimit24V = 29.5;
            const chargingThreshold = 19; // Anything above this might be 24V battery

            const armed = computed(() => { return alarm.armed; });

            function detectBatteryType(voltage: number): "12V" | "24V" {
                return voltage < chargingThreshold ? "12V" : "24V";
            }

            function getBatteryType(voltage: number): string {
                if (voltage === -1) return "Unknown";
                return detectBatteryType(voltage);
            }

            function isVoltageWarning(voltage: number): boolean {
                if (voltage === -1) return false;
                const type = detectBatteryType(voltage);

                return type === "12V"
                    ? voltage < lowVoltageLimit12V || voltage > highVoltageLimit12V
                    : voltage < lowVoltageLimit24V || voltage > highVoltageLimit24V;
            }

            function getVoltage(value: string | undefined): number {
                if (value === "NotPresent") return -1;
                const parsed = parseFloat(value !== undefined && value !== null ? value : "-1");
                return parsed < smallVoltageLimit ? -1 : parsed;
            }

            const power1 = computed(() => {
                return alarm.alarmStatus &&
                    alarm.alarmStatus.VSupplies &&
                    alarm.alarmStatus.VSupplies[0] &&
                    getVoltage(alarm.alarmStatus.VSupplies[0].V1);
            });

            const power2 = computed(() => {
                return alarm.alarmStatus &&
                    alarm.alarmStatus.VSupplies &&
                    alarm.alarmStatus.VSupplies[0] &&
                    getVoltage(alarm.alarmStatus.VSupplies[0].V2);
            });

            const voltageWarning1 = computed(() => isVoltageWarning(power1.value));
            const voltageWarning2 = computed(() => isVoltageWarning(power2.value));

            const hatchsensorModel = computed<AttachedDeviceModel>(() => {
                return getItem(1);
            });
            const shorePowerModel = computed<AttachedDeviceModel | null>(() => {
                if (!Array.isArray(sensor.devices)) {
                    return null;
                }
                const found = sensor.devices.find((device) => device.attachedDeviceTypeId === 2);
                return found ? found : null;
            });
            const smartplugModel = computed<AttachedDeviceModel>(() => {
                return getItem(3);
            });
            const doorsensorModel = computed<AttachedDeviceModel>(() => {
                return getItem(10);
            });
            const temperatureModel = ref<TemperatureViewModel | null>(null);
            get().then((model: TemperatureViewModel) => {
                temperatureModel.value = model;
            });

            const getItem = (type: number): AttachedDeviceModel => {
                let model: AttachedDeviceModel = new AttachedDeviceModel();
                if (Array.isArray(sensor.devices) && sensor.devices.length > 0) {
                    const foundModel = sensor.devices.find((value: AttachedDeviceModel) => {
                        return value.attachedDeviceTypeId === type;
                    });
                    if (foundModel != null) {
                        return foundModel;
                    }
                }
                model.attachedDeviceTypeId = type;
                return model;
            };

            const doorPaired = computed(() => {
                const model = doorsensorModel.value;
                return model.attachedDeviceId != null && model.attachedDeviceId !== "";
            });

            const hatchPaired = computed(() => {
                const model = hatchsensorModel.value;
                return model.attachedDeviceId != null && model.attachedDeviceId !== "";
            });

            const doorResponsive = computed(() => {
                return doorPaired.value && doorsensorModel.value.age == 0;
            });

            const hatchResponsive = computed(() => {
                return hatchPaired.value && hatchsensorModel.value.age == 0;
            });

            const latitude = computed<string>(() => {
                return alarm.lat ? alarm.lat.toString() : "-.--";
            });

            const longitude = computed<string>(() => {
                return alarm.lng ? alarm.lng.toString() : "-.--";
            });

            const accuracy = computed<string>(() => {
                const location = alarm.lastKnownLocation && alarm.lastKnownLocation.location;
                const accuracyValue = location && location.horizontal_accuracy;

                if (accuracyValue === undefined || accuracyValue === null) {
                    return "-.--";
                }
                console.log("accuracyValue", accuracyValue.toFixed(0) + " m");
                return accuracyValue.toFixed(0) + " m";
            });

            const latLetter = computed<string>(() => parseFloat(latitude.value) >= 0 ? "N" : "S");

            const lngLetter = computed<string>(() => parseFloat(longitude.value) >= 0 ? "E" : "W");

            const statusLoading = computed<boolean>(() => { return alarm.syncStatus; });

            const goToMob = async () => {
                const accessResolution = await resolveGeolocationAccess();
                console.info("[GeoTrace] Home.goToMob resolved permission state", {
                    permissionState: accessResolution.permissionState,
                    accessStatus: accessResolution.accessStatus,
                });

                if (accessResolution.accessStatus === "denied" || accessResolution.accessStatus === "unavailable") {
                    root.$router.push({ name: "geo-permission", query: { destination: "mob" } });
                    return;
                }

                if (accessResolution.accessStatus === "granted") {
                    root.$router.push({ name: "mob" });
                } else {
                    root.$router.push({ name: "geo-permission", query: { destination: "mob" } });
                }
            };

            const generateTimeString = function (days, hours, minutes, seconds) {
                var timestring = "";

                if (days > 0) timestring += days + "d ";
                if (hours > 0 || timestring !== "") timestring += hours + "h ";
                if (minutes > 0 || timestring !== "") timestring += minutes + "m ";
                timestring += seconds + "s";

                return timestring.trim() + " ago";
            };

            const isSilenceSirenAvailable = computed(() => alarm.isSilenceSirenAvailable);

            function stopLastHeardTimer() {
                if (lastHeardIntervalId) {
                    clearInterval(lastHeardIntervalId);
                    lastHeardIntervalId = null;
                }
            }

            function cleanupPageTimers() {
                stopLastHeardTimer();
                lastGpsTime = null;

                if (stopLastKnownLocationWatch) {
                    stopLastKnownLocationWatch();
                    stopLastKnownLocationWatch = null;
                }
            }

            function initTimer(alarmInstance) {
                if (
                    alarmInstance &&
                    alarmInstance.lastKnownLocation &&
                    alarmInstance.lastKnownLocation.location &&
                    alarmInstance.lastKnownLocation.location.last_heard
                ) {
                    const lastHeardStr = alarmInstance.lastKnownLocation.location.last_heard;
                    const lastHeard = new Date(Date.parse(lastHeardStr)); // should be UTC
                    const lastHeardTime = lastHeard.getTime();

                    if (lastGpsTime && lastGpsTime.getTime() !== lastHeardTime) {
                        stopLastHeardTimer();
                    }

                    if (!lastHeardIntervalId) {
                        lastHeardIntervalId = setInterval(() => {
                            const now = new Date(); // current time
                            const nowUtc = now.getTime(); // in ms (UTC)
                            const distance = nowUtc - lastHeardTime;

                            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                            //console.log("distance", distance, "nowUtc", new Date(nowUtc).toISOString(), "lastHeard", lastHeard.toISOString());

                            const timestring = generateTimeString(days, hours, minutes, seconds);
                            gpsLocationAge.value = timestring;
                        }, 1000);
                    }

                    lastGpsTime = lastHeard;
                } else {
                    gpsLocationAge.value = "---";
                    stopLastHeardTimer();
                    lastGpsTime = null;
                }
            }

            const panel = computed<number>({
                get: () => {
                    if (app.getHomePanelOpen) {
                        console.log("app.getHomePanelIndex", app.getHomePanelIndex);
                        return app.getHomePanelIndex;
                    }
                    console.log("app.getHomePanelIndex", -1);
                    return -1;
                },
                set: (next: number) => {
                    app.setHomePanelIndex(next);
                    app.setHomePanelOpen(next !== -1);
                },
            });

            const temperature = computed(() => {
                const model = temperatureModel.value;
                if (
                    model &&
                    model.cabinTemperature !== -273 &&
                    (doorResponsive.value || hatchResponsive.value)
                ) {
                    return model.cabinTemperature.toFixed(1);
                }
                return "-.--";
            });

            function openEnroll(payload: { typeId: number; img: string }) {
                enrollState.startEnrollment(payload.typeId);
                enrollUi.open(payload.img);
                console.log("Home openDialog", payload);
            }

            function unpair(payload: { deviceId: string }) {
                console.log("Home unpair", payload);
                sensor.UnpairDevice(payload.deviceId);
            }

            onMounted(() => {
                alarm.getGeoLocation();
                alarm.fetchSecondsSinceLastAlarm();
                stopLastKnownLocationWatch = alarm.$watch(function (m) { return m.lastKnownLocation; }, function () {
                    initTimer(alarm);
                });
                initTimer(alarm);
                sensor.GetData();

                // Print door model and hatch model to console
                console.log("doorsensorModel age", doorsensorModel.value.age);
                console.log("doorsensorModel isConnecting", doorsensorModel.value.isConnecting);
                console.log("hatchsensorModel age", hatchsensorModel.value.age);
                console.log("hatchsensorModel isConnecting", hatchsensorModel.value.isConnecting);
            });

            onBeforeUnmount(() => {
                cleanupPageTimers();
            });

            return {
                armed,
                power1,
                power2,
                shorePowerModel,
                smartplugModel,
                doorsensorModel,
                hatchsensorModel,
                latitude,
                longitude,
                statusLoading,
                showGrafDialog1,
                showGrafDialog2,
                connectSensor,
                gpsLocationAge,
                openEnroll,
                unpair,
                temperature,
                accuracy,
                latLetter,
                lngLetter,
                voltageWarning1,
                voltageWarning2,
                goToMob,
                getBatteryType,
                isSilenceSirenAvailable,
                panel
            };
        }
    });

    @Component({})
    class Home extends Vue {
        public showGrafDialog1: boolean = false;
        public showGrafDialog2: boolean = false;
        public connectSensor: AttachedDeviceModel | null = null;
    }
</script>
<style scoped>
    .sep {
        display: inline-block;
        margin: 0 12px; /* tweak to taste */
        opacity: 0.7; /* optional: softer divider */
    }
</style>